import { c as _c } from "react/compiler-runtime";
import type React from "react";

/**
 * Blacksmith logomark on a square canvas so it aligns with the Simple
 * Icons glyphs McpProviderIcon renders for other providers. Used for
 * first-party MCP servers codesmith injects (e.g. the Blacksmith Browser).
 */
export const BlacksmithMcpIcon: React.FC<{
  className?: string;
  size?: number | string;
}> = t0 => {
  const $ = _c(5);
  const {
    className,
    size: t1
  } = t0;
  const size = t1 === undefined ? 14 : t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <title>Blacksmith</title>;
    t3 = <path fill="currentColor" d="M144 95.937H48l-.016-1.238C47.327 68.796 26.095 48 0 48V.063h144v95.874Z" />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== className || $[3] !== size) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144 96" width={size} height={size} preserveAspectRatio="xMidYMid meet" className={className} aria-hidden={true}>{t2}{t3}</svg>;
    $[2] = className;
    $[3] = size;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};